import "./_connect-wallet-modal.scss";

import {useState} from "react";
import {List, ListItem} from "@hipo/react-ui-toolkit";
import classNames from "classnames";

import ModalHeader from "../../../component/modal/header/ModalHeader";
import Modal from "../../../component/modal/Modal";
import {AVAILABLE_WALLETS} from "../../util/walletConstants";
import {Wallet, WalletType} from "../../util/walletTypes";
import Typography from "../../../component/typography/Typography";

interface ConnectWalletModalProps {
  onClose: () => void;
  onConnect: (walletType: WalletType) => void;
}

function ConnectWalletModal({onClose, onConnect}: ConnectWalletModalProps) {
  const [selectedWalletType, setSelectedWalletType] = useState<WalletType>();

  return (
    <Modal
      isOpen={true}
      contentLabel={"Connect Wallet"}
      customClassName={"connect-wallet-modal"}
      shouldCloseOnOverlayClick={true}
      onClose={onClose}>
      <ModalHeader
        title={selectedWalletType ? undefined : "Connect to a wallet"}
        closeButtonProps={{onClick: onClose, "aria-label": "Close Connect Wallet Modal"}}
      />

      <List
        customClassName={"connect-wallet-modal__wallet-select-view is-flex-column"}
        testid={"ConnectWalletModal.AVAILABLE_WALLETS"}
        items={AVAILABLE_WALLETS}>
        {(wallet, testid) => (
          <ListItem
            testid={testid}
            customClassName={classNames(
              "is-flex-column",
              "connect-wallet-modal__available-wallet",
              `connect-wallet-modal__available-wallet--${wallet.id}`
            )}
            clickableListItemProps={{onClick: selectWalletType(wallet)}}>
            <div className={"is-vertically-centered"}>
              <img
                src={wallet.logo}
                alt={wallet.logoAlt}
                className={"connect-wallet-modal__available-wallet__logo"}
              />

              <Typography
                as={"h3"}
                variant={"body"}
                fontWeight={"bold"}
                customClassName={"connect-wallet-modal__available-wallet__title"}>
                {wallet.title}
              </Typography>
            </div>

            {wallet.description && (
              <Typography
                as={"p"}
                variant={"caption"}
                fontWeight={"normal"}
                textColor={"text-gray"}
                customClassName={"connect-wallet-modal__available-wallet__description"}>
                {wallet.description}
              </Typography>
            )}
          </ListItem>
        )}
      </List>
    </Modal>
  );

  function selectWalletType(wallet: Wallet) {
    return () => {
      setSelectedWalletType(wallet.id);
      onConnect(wallet.id);
    };
  }
}

export default ConnectWalletModal;
